import React from 'react';
import { Link } from 'react-router-dom';
import './FirstVisionWelcome.css';

const FirstVisionWelcome = ({ userName }) => {
  return (
    <div className="fvw-wrap">
      <div className="fvw-header">
        <span className="fvw-eyebrow">Welcome to dmyor</span>
        <h1 className="fvw-title">
          {userName ? `Hey ${userName.split(' ')[0]}, ` : ''}here's how this works.
        </h1>
        <p className="fvw-sub">
          Three things to know before you start. Takes 20 seconds.
        </p>
      </div>

      <div className="fvw-steps">
        <div className="fvw-step">
          <div className="fvw-step-num">01</div>
          <div className="fvw-step-icon" aria-hidden="true">
            <svg viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="13" stroke="#f17501" strokeWidth="1.5"/>
              <circle cx="16" cy="16" r="5" fill="#f17501"/>
            </svg>
          </div>
          <h3 className="fvw-step-title">Vision</h3>
          <p className="fvw-step-desc">
            The big picture. Your 1-5 year commitment. Like "build a profitable business" or "get in best shape ever."
          </p>
        </div>

        <div className="fvw-connector" aria-hidden="true">→</div>

        <div className="fvw-step">
          <div className="fvw-step-num">02</div>
          <div className="fvw-step-icon" aria-hidden="true">
            <svg viewBox="0 0 32 32" fill="none">
              <rect x="6" y="5" width="20" height="22" rx="2" stroke="#f17501" strokeWidth="1.5"/>
              <line x1="10" y1="11" x2="22" y2="11" stroke="#f17501" strokeWidth="1.5"/>
              <line x1="10" y1="16" x2="22" y2="16" stroke="#f17501" strokeWidth="1.5"/>
              <line x1="10" y1="21" x2="18" y2="21" stroke="#f17501" strokeWidth="1.5"/>
            </svg>
          </div>
          <h3 className="fvw-step-title">Records</h3>
          <p className="fvw-step-desc">
            The specific things you write inside a Vision. Each one tracked, updated, and timestamped as you build.
          </p>
        </div>

        <div className="fvw-connector" aria-hidden="true">→</div>

        <div className="fvw-step">
          <div className="fvw-step-num">03</div>
          <div className="fvw-step-icon" aria-hidden="true">
            <svg viewBox="0 0 32 32" fill="none">
              <path d="M16 4 L26 12 L22 28 L10 28 L6 12 Z" stroke="#f17501" strokeWidth="1.5" fill="none"/>
              <path d="M12 17 L15 20 L21 13" stroke="#f17501" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h3 className="fvw-step-title">Release</h3>
          <p className="fvw-step-desc">
            When you've made it real, release the record. Your name appears. Permanent proof of what you said and did.
          </p>
        </div>
      </div>

      <div className="fvw-cta-row">
        <Link to="/dashboard/start" className="fvw-cta-primary">
          Create your first Vision
        </Link>
        <p className="fvw-cta-note">No commitment. Takes a minute.</p>
      </div>
    </div>
  );
};

export default FirstVisionWelcome;
